import {ActionTree} from "vuex";
import {RootState} from "../types/RootState";
import { BackgroundViewState } from "../types/BackgroundViewState";
import { BroadcastQueParams } from "@service/components/background-view/types/BroadcastQueParams";
import { BackgroundViewName } from "@service/components/background-view/types/BackgroundViewName";

export const actions: ActionTree<BackgroundViewState, RootState> = {
    updateBroadcastQue({ commit }, params: BroadcastQueParams) {
        if (params.isLive) {
            commit("setSingleBroadcast", params);
        }
        else {
            commit("deleteFromQue", params.viewName);
        }
    },
    stopBroadcast({ commit }, viewName: BackgroundViewName) {
        commit("deleteFromQue", viewName);
    },
    setOffline({ commit }, viewName) {
        commit("setSingleBroadcast", { viewName, isLive: false } as BroadcastQueParams);
    },
    initNewBroadcast({ commit }, viewName) {
        commit("updateQue", {viewName, isLive: false});
    },
    clearBroadcastQue({ commit }) {
        commit("setQue", {});
    }
};